const UrlName = '/order/v1';
export default API => ({
    getDefaultAddress() {
        return API({
            url: `${UrlName}/open/userAddr/findMyDefault`,
        });
    },
    getAddressList(params) {
        return API({
            url: `${UrlName}/open/userAddr/findMyList`,
            params,
        });
    },
    saveAddress(data) {
        return API({
            url: `${UrlName}/open/userAddr/save`,
            method: 'post',
            data,
        })
    },
    deleteAddress(data) {
        return API({
            url: `${UrlName}/open/userAddr/delete`,
            method: 'post',
            data,
        })
    },
    getAddressDetail(params) {
        return API({
            url: `${UrlName}/open/userAddr/detail`,
            params,
        })
    },
    
});